// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { GetStampsByAlarmHistoryArgs_abstract } from './../../abstract/SagaBase/Defines/GetStampsByAlarmHistoryArgs_abstract';
export class GetStampsByAlarmHistoryArgs extends GetStampsByAlarmHistoryArgs_abstract {}
